import openReplay from '@shared/app/openreplay'

export default defineNuxtPlugin((nuxtApp) => {

  // Install the openreplay plugin
  openReplay.install(nuxtApp.vueApp)

  // Are we configured for openreplay?
  if (useRuntimeConfig()?.public?.openReplay?.enabled) {

    // We don't really know how to identify as a user here (yet).
    false && openReplay.identify('' /* getDeploymentId() */)

    // Initialize OpenReplay
    openReplay.init()
  }
})
